import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../app.reducer';
import * as UI from '../../shared/store/ui.actions';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    isAuthenticated$: Observable<{ isAuthenticated: boolean }> = this.oidcSecurityService.isAuthenticated$;

    constructor(
        private oidcSecurityService: OidcSecurityService,
        private store$: Store<fromRoot.State>
    ) {}

    login(): void {
        this.oidcSecurityService.authorize(undefined, {
            customParams: { prompt: 'select_account' }
        });
    }

    logout(): void {
        this.oidcSecurityService.logoff().subscribe();
    }

    getToken(): Observable<string> {
        return this.oidcSecurityService.getAccessToken();
    }

    checkAuthAndLoadUser(): void {
        this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
            if (isAuthenticated) {
                this.store$.dispatch(new UI.GetUserInfo());
            }
        });
    }
}
